<template>
  <form class="uk-form-stacked" @submit.prevent="validateBeforeSubmit">
    <input type="hidden">
    <div class="uk-grid" uk-grid v-if="!success">
      <div :class="'uk-width-' + group.width + '@m'" v-for="group in formFields.groups" :key="group.id">
        <div v-if="group.legend">
          <div class="uk-h4" v-html="group.legend"></div>
        </div>
        <div class="uk-grid uk-grid-medium" uk-grid>
          <div :class="field.width || 'uk-width-1-1'" v-for="field in group.fields" :key="field.name">
            <template v-if="showField(field.condition)">
              <!--<component v-bind:is="'app-' + field.type"></component>-->
              <template v-if="field.type === 'honeypot'">
                <app-input
                  type="text"
                  :name="field.name"
                  classes="email"
                  v-model="form[field.name]"
                ></app-input>
              </template>
              <template v-if="field.type === 'text' || field.type === 'number'">
                <app-label :forInput="field.name" class="uk-form-label" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-input
                  :type="field.type"
                  :name="field.name"
                  :classes="field.classes || ''"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                ></app-input>
              </template>
              <template v-if="field.type === 'calendar'">
                <app-label :forInput="field.name" class="uk-form-label" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-calendar
                  :type="field.type"
                  :name="field.name"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                ></app-calendar>
              </template>
              <template v-if="field.type === 'datepicker'">
                <app-label :forInput="field.name" class="uk-form-label" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-datepicker
                  :type="field.type"
                  :name="field.name"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                ></app-datepicker>
              </template>
              <template v-if="field.type === 'textarea'">
                <app-label :forInput="field.name" class="uk-form-label" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-textarea
                  :name="field.name"
                  v-model="form[field.name]"
                  :val="field.value"
                  :label="$t(field.label)"
                  :rows="field.rows"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :errors="formErrors[field.name]"
                ></app-textarea>
              </template>
              <template v-if="field.type === 'select'">
                <app-label :forInput="field.name" class="uk-form-label" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-select
                  :name="field.name"
                  :options="field.options"
                  v-model="form[field.name]"
                  v-validate="{ required: field.rules.indexOf('required') !== -1 }"
                  :error="errors.first(field.name)"
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :errors="formErrors[field.name]"
                ></app-select>
              </template>
              <template v-if="field.type === 'make-models'">
                <app-label :forInput="field.name" class="uk-form-label" v-if="field['label_position'] === 'label'">
                  {{ $t(field.label) }}
                  <span v-if="field.rules.indexOf('required') !== -1">*</span>
                </app-label>
                <app-make-models
                  :placeholder="field['label_position'] === 'placeholder' ? $t(field.label) + (field.rules.indexOf('required') !== -1 ? '*' : '') : ''"
                  :errors="formErrors[field.name]"
                  @change="onMakeModelChange"
                ></app-make-models>
              </template>
              <template v-if="field.type === 'upload'">
                <div class="uk-margin">
                  <h5 v-html="$t(field.label)"></h5>
                  <file-upload url="/wp-json/ansolution/v1/forms/image-upload" :type="field['upload_type']"
                               :data="{ id: id }" @uploaded="addImageUuid" @removed="removeImageUuid"></file-upload>
                </div>
              </template>
              <template v-if="field.type === 'checkbox'">
                <app-checkbox
                  :label="field.label"
                  :value="field.value"
                  :name="field.name"
                  v-model="form[field.name]"
                  :shouldValidate="field.rules.indexOf('required') !== -1"
                  :error="errors.first(field.name)"
                  :text-small="field.options.textsize === 'small'"
                ></app-checkbox>
              </template>
              <template v-if="field.type === 'checkbox-group'">
                <app-checkbox-group :label="$t(field.label)" :options="field.options" v-model="form[field.name]"
                                    :errors="formErrors[field.name]"></app-checkbox-group>
              </template>
              <template v-if="field.type === 'radio'">
                <app-radio
                  :label="$t(field.label)"
                  :initial-value="field.value"
                  :name="field.name"
                  :options="field.options"
                  v-model="form[field.name]"
                  :shouldValidate="field.rules.indexOf('required') !== -1"
                  :error="errors.first(field.name)"
                ></app-radio>
              </template>
              <template v-if="field.type === 'textField'">
                <app-text :value="field.value"></app-text>
              </template>
              <!--
              <template v-if="field.type === 'captcha'">
                <div class="uk-margin">
                  <div class="uk-grid" uk-grid>
                    <div class="uk-width-auto uk-width-1-2"><img :src="captcha" alt="captcha" /><br /></div>
                    <div class="uk-width-1-6@m uk-margin-remove">
                      <a href="#" @click.prevent="refreshCaptcha()" class="uk-button uk-button-link" style="margin-top: 5px">
                        <span uk-icon="refresh"></span>
                      </a>
                    </div>
                  </div>
                  <div class="uk-grid" uk-grid>
                    <div class="uk-width-1-4@m uk-width-1-2">
                      <input type="text" name="captcha" v-model="form.captcha" placeholder="Captcha*" class="uk-input" :class="{ 'uk-form-danger': formErrors['captcha'] }" />
                    </div>
                  </div>
                </div>
              </template>
              -->
            </template>
          </div>
        </div>
      </div>
      <div class="uk-margin-small">
        <p class="uk-text-small">{{ $t('*Pflichtfelder') }}</p>
        <p class="uk-text-danger" v-if="errors.items.length">
          {{ $t('Bitte Pflichtfelder beachten!') }}
        </p>
        <!--
        <div class="uk-margin-small">
          <p class="uk-text-muted uk-text-small">
            Diese Website ist durch reCAPTCHA von Google geschützt. <br />
            Für reCAPTCHA gelten die Google-<a href="https://policies.google.com/privacy" class="uk-link-reset" target="_blank" style="font-weight: bold !important">Datenschutzerklärung</a> und -<a
              href="https://policies.google.com/terms"
              class="uk-link-reset"
              target="_blank"
              style="font-weight: bold !important"
              >Nutzungsbedingungen</a
            >.
          </p>
        </div>
      -->
        <button type="submit" class="uk-button uk-width-medium uk-button-primary uk-text-bold uk-margin"
                :disabled="waiting">
          <div v-if="waiting" uk-spinner="ratio: 0.6"></div>
          <span v-if="!waiting" class="uk-icon" uk-icon="icon: mail"></span>
          {{ $t('Absenden') }}
        </button>
      </div>
    </div>

    <div class="uk-container" v-else>
      <div class="uk-grid uk-flex-center uk-text-center uk-margin-large-top" uk-grid>
        <div class="uk-width-3-4@m uk-width-1-1">
          <div class="uk-padding">
            <div class="uk-text-large uk-text-bold">
              <div class="uk-h2">{{ $t('Vielen Dank für Ihre Anfrage') }}</div>
            </div>
            <div class="uk-flex@m uk-flex-middle@m uk-flex-center@m uk-margin-small">
              <p>
                {{ $t('Wir werden uns mit Ihnen in kürzester Zeit in Verbindung setzen.') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios'
import AppInput from './form/input.vue'
import AppTextarea from './form/textarea.vue'
import AppSelect from './form/select.vue'
import AppMakeModels from './form/make-models.vue'
import AppLabel from './form/label.vue'
import AppCheckbox from './form/checkbox.vue'
import AppCheckboxGroup from './form/checkbox-group.vue'
import AppRadio from './form/radio.vue'
import FileUpload from './file-upload.vue'
import AppCalendar from './form/calendar.vue'
import AppDatepicker from './form/datepicker.vue'
import AppText from './form/text.vue'

import Vue from 'vue'
import VeeValidate from 'vee-validate'

//import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VeeValidate)
//Vue.use(VueReCaptcha, { siteKey: window.captcha })

export default {
  props: {
    id: {
      required: true,
    },
    successMessage: {
      required: false,
    },
    extraData: {
      required: false,
    },
    settings: {
      required: false,
    },
    prefill: {
      required: false,
    },
    prefillDealer: {
      required: false,
    },
    reloadPage: {
      required: false,
    },
  },

  components: {
    AppInput,
    AppTextarea,
    AppSelect,
    AppCheckbox,
    AppCheckboxGroup,
    AppLabel,
    FileUpload,
    AppRadio,
    AppMakeModels,
    AppCalendar,
    AppText,
    AppDatepicker,
  },

  data() {
    return {
      form: {
        images: [],
        privacy: false,
      },
      formFields: [],
      formErrors: {},
      waiting: false,
      success: false,
      mergedExtraData: {},
      languages: ['de', 'en', 'es', 'fr', 'it', 'ro', 'pl', 'pt-pt', 'ru'],
      captchaVerified: false
    }
  },

  mounted() {
    const checkedLang = window.location.pathname.split('/')[1]
    if (this.languages.includes(checkedLang)) {
      this.$i18n.locale = checkedLang
    } else {
      this.$i18n.locale = 'de'
    }
    this.getFields()

    if (this.localExtraData) {
      this.mergedExtraData = this.localExtraData
    }

    if (this.settings) {
      _.forEach(this.settings, (v, k) => {
        this.mergedExtraData[k] = v
      })
    }

    if (this.prefillDealer) {
      const dealerData = JSON.parse(window.kfzDealer)[0]

      this.form.name = dealerData.company
      this.form.email = dealerData.email
      this.form.telefon = dealerData.phone
    }

    if (this.prefill) {
      const prefillData = JSON.parse(this.prefill)
      _.forEach(prefillData, (v, k) => {
        this.form[k] = v
      })
    }
  },

  computed: {
    localExtraData() {
      return typeof this.extraData !== 'undefined' ? JSON.parse(this.extraData) : null
    },
  },

  methods: {
    showField(condition) {
      if (typeof condition !== 'undefined' && condition.split('_').length === 2) {
        const splitted = condition.split('_')
        if (this.form[splitted[0]] === true || this.form[splitted[1]] === true) {
          return true
        }

        if (this.form[splitted[0]] === 'true' || this.form[splitted[1]] === 'true') {
          return false
        }

        if (typeof this.form[splitted[0]] === 'undefined' || (typeof this.form[splitted[0]] !== 'undefined' && this.form[splitted[0]] !== splitted[1])) {
          return false
        }
      }
      if (typeof this.form[condition] !== 'undefined' && (this.form[condition] === 'Nein' || this.form[condition] === true)) {
        return false
      }
      return true
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        //if(typeof window.knumber !== 'undefined' && window.knumber === 'K10038') { // a1a only
        //  if(typeof _.find(this.errors.items, e => e.field === 'privacy') !== 'undefined') {
        //    this.form.privacy = true
        //     this.$validator.reset();
        //  }
        //}
        if (result) {
          //this.$recaptchaLoaded().then(() => {
          //  console.log('recaptcha loaded')
          //  this.$recaptcha('login').then((toke¶n) => {
          this.submit()
          //  })
          //})
        }
      })
    },
    getFields() {
      axios.get(`/wp-json/ansolution/v1/forms/${this.id}`).then((response) => {
        /*
        fields.groups.push({id:null, fields: [{
            label: 'E-Mail',
            label_position: null,
            name: 'wvb9gne24',
            rules: ["required", "email"],
            type: 'email',
            classes: 'email'
          }]})
         */
        this.formFields = response.data.fields
      })
    },
    onMakeModelChange(data) {
      _.forEach(data, (v, k) => {
        this.form[k] = v
      })
    },
    onCaptchaVerify(token, eKey) {
      this.captchaVerified = true
    },
    onCaptchaExpire: () => {
      //console.log('Token expired')
    },
    onCaptchaError: (err) => {
      //console.log('Error', err)
    },
    async submit() {
      this.waiting = true
      this.success = false
      try {
        axios
          .post('/wp-json/ansolution/v1/forms/' + this.id + '/message', _.merge(this.form, {extraData: this.mergedExtraData}))
          .then(() => {
            this.waiting = false
            this.success = true
            this.form = {
              images: [],
              privacy: true,
            }
            this.formErrors = {}

            if (this.reloadPage) {
              setTimeout(() => {
                window.location.reload()
              }, 5000)
            }

            setTimeout(() => {
              this.success = false
            }, 10000)
          })
          .catch((error) => {
            this.waiting = false
            this.success = false
            this.formErrors = error.response.data
          })
      } catch (error) {
        this.waiting = false
        this.success = false
        //console.log(error);
      }

    },

    addImageUuid(data) {
      this.form.images.push(data)
    },
    removeImageUuid(index) {
      this.form.images.splice(index, 1)
    },
  },
}
</script>

